import React from 'react'
import t from 'prop-types'
import Card from '../Card'
import SectionHeader from '../../Headers/SectionHeader/SectionHeader'
import TwoUp from '../../Layouts/TwoUp'

const CardGroup = ({ cards, sectionHeader }) => {
  return (
    <>
      {sectionHeader && (
        <div className="mb-16">
          <SectionHeader {...sectionHeader}></SectionHeader>
        </div>
      )}
      <TwoUp>
        {cards.map((card, index) => (
          <Card key={index} {...card} />
        ))}
      </TwoUp>
    </>
  )
}

CardGroup.propTypes = {
  cards: t.object,
  sectionHeader: t.object,
}

CardGroup.defaultProps = {}

export default CardGroup
